module.exports = App.LoyaltyProgram = DS.Model.extend
  name:    DS.attr 'string'
  kind:    DS.attr 'string'
  details: DS.attr 'mixed'

  selectedKind: null
  additionalInfo: null
  additionalFields: []

  additionalInfoObserver: (->
    return unless @get('additionalInfo')
    @set('additionalFields', [])
    kind = @get('kind')
    info = @get('additionalInfo').find (item) => item.name == kind
    return {} if Ember.isEmpty(info)
    fields = info.fields.map (field) =>
      isNumber = field.type in ['Integer', 'Float']
      fieldType = if isNumber then 'isNumber' else "is#{field.type}"
      fieldText =   
        placeholder: field.locales[Em.I18n.locale]
        label: field.locales[Em.I18n.locale]
      Ember.set(field, fieldType , true)
      Ember.set(field, 'text', fieldText)
      Ember.set(field, 'value', if @get('details') then @get('details')[field.name] else null)
      field
    @set('additionalFields', fields)
  ).observes('additionalInfo', 'kind')

  programTypeText: (->
    return unless @get('additionalInfo')
    kind = @get('kind')
    info = @get('additionalInfo').find (item) => item.name == kind
    info.locales[Em.I18n.locale]
  ).property('kind')
